export default  [
  {
    id: 'cbdemo_grow',
    name: 'Full Access',
    billingPeriod: 'Indefinite',
    price: 0
  },
]
